import React from "react";
import * as Animate from "react-reveal";
import ButtonLink from "../../../components/elements/ButtonLink";
import { scrollToTop } from "../../../utils/scrollToTop";

const Career = ({ title }) => {
  return (
    <div className="flex flex-row items-baseline">
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5625 7.30121C12.8699 6.99382 12.8699 6.49544 12.5625 6.18805L7.5533 1.17884C7.24591 0.871448 6.74753 0.871448 6.44014 1.17884C6.13275 1.48623 6.13275 1.98461 6.44014 2.292L10.8928 6.74463L6.44014 11.1973C6.13275 11.5047 6.13275 12.003 6.44014 12.3104C6.74753 12.6178 7.24591 12.6178 7.5533 12.3104L12.5625 7.30121ZM0.902344 7.53175H12.0059V5.95751H0.902344V7.53175Z"
          fill="white"
        />
      </svg>
      <span className="pl-2">{title}</span>
    </div>
  );
};

const GetStartedSection = ({ selectedSchoolData }) => {
  return (
    <section className="relative">
      <div className="flex flex-row flex-wrap">
        <div className="bg-primary2 w-full lg:w-6/12 xl:w-7/12 pl-10 md:pl-20 lg:pl-28 py-16 lg:py-20">
          <div className="">
            <Animate.Fade bottom>
              <h2 className="w-full lg:w-8/12 text-white text-3xl lg:text-4xl xl:text-5xl xl:leading-tight font-mono font-semibold">
                Begin your {selectedSchoolData?.tag?.toLowerCase() || "data"}{" "}
                journey <span className="text-gradient">with Utiva</span>
              </h2>

              <p className="mt-8 lg:mt-10 text-white font-semibold text-base lg:text-lg">
                Possible career path in{" "}
                {selectedSchoolData?.tag || "Data Science"}
              </p>

              <div className="mt-6 text-white text-sm lg:text-sm-15 grid grid-cols-2 gap-x-4 gap-y-8 w-full md:w-10/12 lg:w-8/12">
                {selectedSchoolData?.careerPaths ? (
                  <>
                    {selectedSchoolData?.careerPaths?.map((a, i) => (
                      <Career key={i} title={a} />
                    ))}
                  </>
                ) : (
                  <>
                    {[
                      "Data Analyst",
                      "Data Engineer",
                      "Data Scientist",
                      "Business Analyst",
                    ]?.map((a, i) => (
                      <Career key={i} title={a} />
                    ))}
                  </>
                )}
              </div>

              <div className="mt-10 lg:mt-12">
                <ButtonLink
                  url={
                    selectedSchoolData?.url
                      ? `/school${selectedSchoolData?.url}`
                      : "/school/data-school"
                  }
                  title="Get Started"
                  withDropShadow={false}
                  onClick={() => scrollToTop()}
                />
              </div>
            </Animate.Fade>
          </div>
        </div>

        <div className="bg-blue2 w-full lg:w-6/12 xl:w-5/12 pl-10 lg:pl-16 pr-6 md:pr-20 lg:pr-28 py-16 lg:py-20">
          <h3 className="text-white text-2xl lg:text-3xl font-mono font-semibold">
            Quick Facts
          </h3>

          <div className="mt-14 ml-4 w-7/12 relative course-fact-card">
            <div className="w-full h-16 mt-2 bg-secondary absolute top-0 -left-1"></div>
            <div className="bg-darkgreen px-4 py-4 relative -left-3 -top-4">
              <p className="text-white font-medium font-mono text-3xl lg:text-5xl">
                {selectedSchoolData?.quickFactSalary || "$70,000"}
              </p>
            </div>
          </div>

          <div className="mt-6 md:mt-2">
            <p className="text-white text-base lg:text-lg">
              Average salary of a{" "}
              {selectedSchoolData?.careerTitle || "Data Analyst"}
            </p>
            <p
              className="mt-2 text-sm lg:text-sm-15"
              style={{ color: "#686BFF" }}
            >
              Source: Glassdoor
            </p>

            <div className="mt-6 lg:mt-8">
              <ul className="text-sm lg:text-sm-15 list-disc list-outside space-y-5 ml-4 text-white">
                {selectedSchoolData?.quickFacts ? (
                  <>
                    {selectedSchoolData?.quickFacts?.map((a, i) => (
                      <li key={i}>{a}</li>
                    ))}
                  </>
                ) : (
                  <>
                    {[
                      `Data science was identified as the skill with the largest
                   skill gap, according to a 2021 report by the World Economic
                   Forum.`,
                      `In 2020 the number of data science job listings outstripped
                   the number of people searching for such jobs by a factor of 3
                   to 1.`,
                    ]?.map((a, i) => (
                      <li key={i}>{a}</li>
                    ))}
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStartedSection;
